import { render, staticRenderFns } from "./BatchSetPriceModal.vue?vue&type=template&id=1480ac4d&scoped=true"
import script from "./BatchSetPriceModal.vue?vue&type=script&lang=js"
export * from "./BatchSetPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480ac4d",
  null
  
)

export default component.exports